import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import api from "../api/api";

const TermsAndConditions = () => {
    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTerms();
    }, []);

    const fetchTerms = async () => {
        try {
            const res = await api.get("/v1/get/termsAndConditions");
            setTerms(res.data.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const formatTextWithLinks = (text) => {
        if (!text) return "";

        // correct spacing for Japanese punctuation
        const formattedText = text.replace(/。）/g, "。 ）");

        const urlRegex = /(https?:\/\/[^\s]+)/g;

        return formattedText.split(urlRegex).map((part, i) => {
            if (part.match(urlRegex)) {
                return (
                    <>
                        {" "}
                        <a
                            key={i}
                            href={part}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "#1976d2",
                                textDecoration: "underline",
                                wordBreak: "break-all",
                                fontSize: "13px",
                                display: "inline"
                            }}
                        >
                            {part}
                        </a>
                    </>
                );
            }
            return part;
        });
    };

    return (
        <Box
            sx={{
                height: "100vh",
                bgcolor: "#f5f6f8", 
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    width: "420px",
                    maxWidth: "95%",
                    height: "97vh",
                    bgcolor: "#fff",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box
                    sx={{
                        p: 3,
                        overflowY: "auto",
                        flex: 1,
                    }}
                >
                    {loading ? (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        terms.map((item, index) => (
                            <Box key={index} sx={{ mb: 3 }}>

                                {item.maincontent && (
                                    <Typography
                                        sx={{
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            mb: 1.5,
                                            whiteSpace: "pre-wrap",
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        {item.maincontent}
                                    </Typography>
                                )}

                                {item.content && (
                                    <Typography
                                        sx={{
                                            fontSize: "13px",
                                            color: "#333",
                                            whiteSpace: "pre-wrap",
                                            lineHeight: 1.9,
                                        }}
                                    >
                                        {formatTextWithLinks(item.content)}
                                    </Typography>
                                )}
                            </Box>
                        ))
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default TermsAndConditions;